import React from 'react'
import { Link } from 'react-router-dom';
import LinkBuilder from '../components/LinkBuilder.js';
import '../styles/quicklinks.css';

const QuickLinks = ({ list }) => {
  return (
    <section className="bl-quick-links section-block">
      <div className="quick-links-container">
        {list.map((unit, index) => (
          <Link to={LinkBuilder(unit.url)} className='gr-quick-link noHover'>
            <div className="quick-link-content">
              <div className='el-nav-url'>
                  <div className='el-nav-name'>
                    {unit.name}
                  </div>
                  <img className='el-nav-icon' src='/icons/sector-unit-arrow.svg' alt="" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default QuickLinks;